// src/components/FipeVersionFilter.jsx

// Normaliza: remove acentos, deixa minúsculo, colapsa espaços
function norm(s = "") {
  return String(s)
    .normalize("NFD").replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * Tenta casar por substring usando prefixos progressivamente mais curtos do modelo.
 * Ex.: "polo track ma" → tenta "polo track ma", se não achar tenta "polo track".
 * Se não achar nada, retorna todos.
 */
export function filterByModelSubstring(modelName = "", items = []) {
  const nModel = norm(modelName);
  const tokens = nModel.split(" ").filter(Boolean);
  const nItems = items.map(it => ({ ...it, _n: norm(it.texto_modelo || it.name || "") }));

  // gera chaves do mais específico pro mais geral
  const keys = [];
  for (let len = tokens.length; len >= 2; len--) {
    keys.push(tokens.slice(0, len).join(" "));
  }
  if (tokens.length === 1) keys.push(tokens[0]);

  for (const key of keys) {
    const matched = nItems.filter(it => it._n.includes(key));
    if (matched.length > 0) {
      // remove campo auxiliar _n antes de retornar
      return {
        list: matched.map(({ _n, ...rest }) => rest),
        meta: { usedKey: key, fellBackToAll: false, total: items.length }
      };
    }
  }

  // fallback: nada casou → devolve tudo
  return {
    list: items,
    meta: { usedKey: null, fellBackToAll: true, total: items.length }
  };
}

/**
 * Componente de filtro por substring de modelo.
 * Props:
 * - modelText: string do modelo (ex.: dados.MODELO)
 * - items: array de itens FIPE (cada item deve ter 'texto_modelo')
 * - children: função (list, meta) => JSX
 */
export default function FipeVersionFilter({ modelText, items, children }) {
  const { list, meta } = filterByModelSubstring(modelText, items);
  return children(list, meta);
}
